/**
 * WHO THE CUSTOMER IS PAYING, IN ONE PLACE.
 *
 * The legal entity and the support address are what a footer owes anybody on a
 * page they can pay through — not decoration that belongs to the landing page.
 * That means more than one footer draws them, and a company name typed into two
 * components is a company name that drifts.
 *
 * WHY THIS MODULE EXISTS AT ALL. The compact footer lost both lines when it was
 * stripped down (75db16e5): the site footer kept `© 2026 Escuela de tenis ITS
 * S.R.L.` and the contact address, the player surfaces and the workspace kept
 * neither. Restoring them by retyping the company name into a second component
 * would have fixed today's gap and set up tomorrow's, so both footers read them
 * from here instead.
 *
 * THE YEAR IS COMPUTED, NEVER TYPED. The site footer carried a hardcoded 2026
 * while the club storefront computed `new Date().getFullYear()` for the club's
 * own line. One of those two was going to be wrong on 1 January and no check
 * anywhere would have said so. `companyCopyright()` applies the storefront's
 * rule to ours.
 *
 * THE ADDRESS IS INTERIM — a personal inbox, to be swapped for a branded one
 * before public launch. That is the other reason it belongs to one module: the
 * swap should be an edit, not a search.
 *
 * NOT THE ONLY MENTIONS IN THE TREE, deliberately. `/privacy`, `/terms` and
 * `/about` name the entity inside running prose, and the JSON-LD names it as
 * structured data; substituting a constant into a sentence reads worse than the
 * sentence does. This module is the source for the CHROME — the footers — where
 * the same short string is repeated verbatim and has no sentence to live in.
 */

/** The company behind The Racket Center, exactly as the legal pages name it. */
export const COMPANY_LEGAL_NAME = 'Escuela de tenis ITS S.R.L.'

/** Where a customer reaches a human about the platform itself. */
export const SUPPORT_EMAIL = 'rutennis.com@gmail.com'

export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`

/** `© 2026 Escuela de tenis ITS S.R.L.` — with this year's year, always. */
export function companyCopyright(): string {
  return `© ${new Date().getFullYear()} ${COMPANY_LEGAL_NAME}`
}
